import { render } from "./MarkdownViewer.vue?vue&type=template&id=3ac5b340&ts=true"
import script from "./MarkdownViewer.vue?vue&type=script&lang=ts"
export * from "./MarkdownViewer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__